import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RatingStarProps {
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function ChatIcon({ isHover = false, style = {}, ...props }: RatingStarProps) {
  const iconColor = isHover ? RoutalPalette.primary20 : RoutalPalette.neutral60;

  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={{ width: `24px`, height: `24px`, fill: `transparent`, ...style }}>
      <g>
        <path
          d="M22.2961 15.432C22.2961 16.0389 22.0551 16.6208 21.626 17.0499C21.1969 17.479 20.6149 17.7201 20.0081 17.7201H6.27992L1.70386 22.2961V3.99189C1.70386 3.38507 1.94492 2.8031 2.37401 2.37401C2.8031 1.94492 3.38507 1.70386 3.99189 1.70386H20.0081C20.6149 1.70386 21.1969 1.94492 21.626 2.37401C22.0551 2.8031 22.2961 3.38507 22.2961 3.99189V15.432Z"
          stroke={iconColor}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="7.4238" cy="9.71201" r="1.14402" fill={iconColor} />
        <circle cx="12" cy="9.71201" r="1.14402" fill={iconColor} />
        <circle cx="16.5761" cy="9.71201" r="1.14402" fill={iconColor} />
      </g>
    </SvgIcon>
  );
}
